import { ListSubheaderProps } from '@mui/material/ListSubheader';
import { CbridgePalette } from '@cbridge-utils/mui-theme';

export const NavigationHeaderStyle: ListSubheaderProps['sx'] = {
  px: 1.5,
  py: 0.75,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: CbridgePalette.background.h2,
};
